import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';

import RenderTextField from '../../../../utils/renderFields/RenderTextField';
import RenderSelectField from '../../../../utils/renderFields/RenderSelectField';

import countryCode from '../../../../utils/bindings/countryCode';
import getOfferCode from '../../../../utils/bindings/offerCode';

import validate from '../validate';

/**
 * Formulaire permettant de mettre à jours les informations d'une commande
 * dans la partie d'import de commande
 */
let EditCommandBody = ({ accountType }) => (
  <form>
    <Grid container spacing={2}>
      <Grid item md={6}>
        <Field
          name="externalReference"
          label="Référence de la commande"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="offerCode"
          label="Offre de livraison"
          style={{ width: '100%' }}
          component={RenderSelectField}
          datas={getOfferCode(accountType)}
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="pickupPoint.id"
          label="Numéro du point relais"
          style={{ width: '100%' }}
          component={RenderTextField}
          fullWidth
          displayErrorBeforeSubmit
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="insuranceAmount"
          label="Montant de la couverture"
          style={{ width: '100%' }}
          component={RenderTextField}
          displayErrorBeforeSubmit
          type="number"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipient.email"
          label="Email"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipient.lastname"
          label="Nom"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipient.firstname"
          label="Prénom"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipient.phoneNumber"
          label="Numéro de téléphone"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipient.companyName"
          label="Nom de l'entreprise"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipientAddress.street"
          label="Adresse"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipientAddress.street2"
          label="Adresse 2"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipientAddress.complement"
          label="Complément d'adresse"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipientAddress.postalCode"
          label="code postal"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipientAddress.city"
          label="Ville"
          component={RenderTextField}
          displayErrorBeforeSubmit
          fullWidth
          type="text"
        />
      </Grid>

      <Grid item md={6}>
        <Field
          name="recipientAddress.countryCode"
          label="Pays"
          style={{ width: '100%' }}
          component={RenderSelectField}
          displayErrorBeforeSubmit
          datas={countryCode}
          fullWidth
          type="text"
        />
      </Grid>
    </Grid>
  </form>
);

const mapStateToProps = (state, props) => {
  const {
    externalReference,
    recipient,
    insuranceAmount,
    recipientAddress,
    offerCode,
    items,
    customsDeclarations,
    pickupPoint
  } = state.importCommands.commands[props.commandIndex];
  return {
    accountType: state.init.currentAccountInformations.accountType,
    commands: state.importCommands.commands,
    initialValues: {
      insuranceAmount,
      offerCode,
      externalReference,
      recipient,
      recipientAddress,
      customsDeclarations,
      items,
      pickupPoint
    }
  };
};

EditCommandBody = reduxForm({
  form: 'editCommand',
  forceUnregisterOnUnmount: true,
  validate
})(EditCommandBody);

EditCommandBody.propTypes = {
  accountType: PropTypes.string
};

export default connect(mapStateToProps)(EditCommandBody);
